export const FEATURE_ABSURDLY_HIGH_SALARY = 'absurdly-high-salary';
export const FEATURE_AI_AD_WRITING = 'ai-ad-writing';
export const FEATURE_BRANDING = 'branding';
export const FEATURE_CART_AND_PAY_AND_POST_V2 = 'cart-and-pay-and-post-v2';
export const FEATURE_FILTER_CONTENT = 'filter-content';
export const FEATURE_FORCE_ERROR_STATE = 'force-error-state';
export const FEATURE_KEY_SELLING_POINTS = 'key-selling-points';
export const FEATURE_LINKOUT = 'linkout';
export const FEATURE_MANDATORY_QUESTIONS = 'mandatory-questions';
export const FEATURE_PAYMENTS_WIDGET_FOR_ALL_NATION =
  'payments-widget-enabled-for-all-nation';
export const FEATURE_PERMISSIONS = 'permissions';
export const FEATURE_PER_UNIT_BILLING = 'per-unit-billing';
export const FEATURE_PRIVATE_AD = 'private-ad';
export const FEATURE_PSEUDO_LOCALISATION = 'pseudo-localisation';
export const FEATURE_RECOMMENDED_CANDIDATE_PANEL =
  'recommended-candidate-panel';
export const FEATURE_REFRESH = 'refresh';
export const FEATURE_SPONSORED_SLOT = 'sponsored-slot';
export const FEATURE_STYLE_ENHANCEMENT = 'style-enhancement';
export const FEATURE_TEST_SHOPPING_CART = 'test-shopping-cart';
